import { useMemo } from 'react';

import { PRODUCT_TYPES } from '@hero/constants';
import { useGetMerchant } from '@hero/services/merchant-service/hooks';
import { useSearchProducts } from '@hero/services/product-service/hooks';

function useGetCharity() {
  const { data: merchantData } = useGetMerchant({ options: { includeConfigs: true } });
  const charityEnabled =
    merchantData?.configs['config-app-dashboard']?.advanceSettings?.charityEnabled;

  const { data: charities } = useSearchProducts({
    params: {
      filters: {
        charityOnly: true
      }
    },
    options: {
      enabled: charityEnabled,
      staleTime: Infinity,
      cacheTime: Infinity
    }
  });

  const isCharityExist = useMemo(() => charities?.docs?.length > 0, [charities]);

  const anyCharityItemExists = (productList = []) =>
    productList?.length > 0 &&
    !!productList.find(product => product?.meta?.productType === PRODUCT_TYPES.CHARITY);

  return { charityEnabled: !!charityEnabled, anyCharityItemExists, isCharityExist };
}

export { useGetCharity };
